package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationDisease(private val literal: String) : IEnumType {
	太阳病("太阳病"),
	阳明病("阳明病"),
	少阳病("少阳病"),
	少阴病("少阴病"),
	太阴病("太阴病"),
	厥阴病("厥阴病"),
	杂病("杂病"),
	虚劳("虚劳");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_disease"}
	override fun getLiteral(): String {return literal}
}
